import { APP_DATE_FORMAT_MID } from "@/config/constants";
import { IEdoQuiz } from "@/shared/model/edo-quiz.model";
import {
  Avatar,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@/components/ui";
import { ClipboardList, Pencil, MoreVertical, Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { TextFormat } from "react-jhipster";
import { useNavigate } from "react-router-dom";
import { cn } from "@/shared/util/cn";

interface IQuizRowProps {
  quiz: IEdoQuiz;
  openEditDialog: (quiz: IEdoQuiz) => void;
  openDeleteDialog: (quiz: IEdoQuiz) => void;
}

export const QuizRow = (props: IQuizRowProps) => {
  const navigate = useNavigate();
  const [localQuiz, setLocalQuiz] = useState<IEdoQuiz>(props.quiz);
  const { quiz, openDeleteDialog: handleDeleteDialog, openEditDialog: handleEditDialog } = props;

  const handleOpenQuiz = () => {
    navigate(`/quizzes/${quiz.id}`);
  };

  useEffect(() => {
    if (quiz) {
      setLocalQuiz(quiz);
    }
  }, [quiz]);

  return (
    <ListItem
      className={cn(
        "flex w-full items-center gap-3 px-5 py-3.5 transition-colors hover:bg-primary/5"
      )}
    >
      <button
        type="button"
        onClick={handleOpenQuiz}
        className="flex min-w-0 flex-1 cursor-pointer items-center gap-3 text-left"
      >
        <ListItemIcon className="!mr-0 shrink-0">
          <Avatar
            alt={localQuiz.title}
            fallback={localQuiz.title?.[0] ?? "Q"}
            className="h-10 w-10 rounded-2xl bg-primary/10 text-primary"
          />
        </ListItemIcon>
        <ListItemText
          primary={
            <span className="text-sm font-semibold text-[var(--color-mockup-text)]">
              {localQuiz.title}
            </span>
          }
          secondary={
            <span className="text-xs text-[var(--color-mockup-text-light)]">
              <TextFormat
                type="date"
                value={localQuiz.createdAt}
                format={APP_DATE_FORMAT_MID}
                locale="it"
              />
            </span>
          }
          className="min-w-0 flex-1"
        />
      </button>
      <div className="shrink-0" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <IconButton
              aria-label="Menu quiz"
              className="h-8 w-8 rounded-full text-[var(--color-mockup-text-light)] hover:bg-[var(--color-mockup-border)]/50 hover:text-[var(--color-mockup-text)]"
            >
              <MoreVertical className="h-4 w-4" />
            </IconButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="min-w-[180px]">
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault();
                handleEditDialog(localQuiz);
              }}
            >
              <Pencil className="h-4 w-4" />
              Modifica quiz
            </DropdownMenuItem>
            <DropdownMenuItem
              onSelect={(e) => {
                e.preventDefault();
                handleDeleteDialog(localQuiz);
              }}
              className="text-[var(--color-mockup-coral)] focus:text-[var(--color-mockup-coral)]"
            >
              <Trash2 className="h-4 w-4" />
              Elimina quiz
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </ListItem>
  );
};

export default QuizRow;
